import React from 'react';
function ShoppingBasketThumbsDown(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c.29 0 .582.125.755.376l3.981 5.876h4.355c.5 0 .909.403.909.896l-.027.241-.677 2.433A6.972 6.972 0 0018 12c-1.71 0-3.277.613-4.493 1.63A1.82 1.82 0 0012 12.836c-1 0-1.818.806-1.818 1.79 0 .822.568 1.519 1.336 1.728A6.967 6.967 0 0011 19c0 .34.024.674.07 1H6.09a1.804 1.804 0 01-1.745-1.308L2.036 10.39A.744.744 0 012 10.148c0-.493.41-.896.91-.896h4.354l3.981-5.867A.893.893 0 0112 3zm0 2.31L9.273 9.253h5.454L12 5.31z",
    fill: color,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14h1.818v5.4H14V14zm10 4.95c0 .495-.41.9-.91.9h-2.867l.432 2.056.013.145a.674.674 0 01-.2.477l-.482.472-2.99-2.965a.876.876 0 01-.269-.635v-4.5c0-.495.41-.9.91-.9h4.09c.378 0 .7.225.837.549l1.372 3.172c.041.104.064.212.064.329v.86l-.005.004.005.036z",
    fill: color,
    fillRule: "evenodd"
  })));
}
export default ShoppingBasketThumbsDown;